import { useState } from 'react';

import ChartFrame from "./ChartFrame";
import SelectionsArea from "./SelectionsArea";
import defaultSelectedState from "../data/selections/defaultSelectedState.json";

function App() {
  const [selectedState, setSelectedState] = useState(defaultSelectedState);
  const paddingTop = process.env.REACT_APP_IS_EXTERNAL ? "pt-0 sm:pt-0 md:pt-0" : ""
  const maxWidthScreen = process.env.REACT_APP_IS_EXTERNAL ? "max-w-screen-lg " : "max-w-screen-xl "
  return (
    <div className={"container mx-auto py-10 sm:py-15 md:py-20 px-0 " + maxWidthScreen + paddingTop}>
      <SelectionsArea
        selectedState={selectedState}
        onBaseSelectionChange={ changedSelections => {
          setSelectedState({ ...selectedState, ...changedSelections })
        } }
        onPartSelectionChange={ changedSelections => {
          setSelectedState({ ...selectedState, ...changedSelections })
        } }
        onSectionSelectionChange={ changedSelections => {
          setSelectedState({ ...selectedState, ...changedSelections })
        } }
      />
      <ChartFrame
        selectedState={selectedState}
      />
    </div>
  );
}

export default App;
